import type { Step } from 'react-joyride';

export const VALUE_PROVIDER_TOUR_CONTAINER_ID = 'value-provider-tour-container';

interface GetValueProviderTourStepsProps {
  submitAction: () => Promise<void>;
}

export function cardValueProviderTourSteps({ submitAction }: GetValueProviderTourStepsProps): Step[] {
  return [
    {
      title: 'Fill it yourself',
      content: 'Ideal if you’re creating a card for your own use.',
      data: { image: '/img/placeholders/card-placeholder-1.png' },
      styles: {
        options: {
          width: 300,
        },
      },
      target: `#${VALUE_PROVIDER_TOUR_CONTAINER_ID}`,
      placement: 'left',
      disableBeacon: true,
    },
    {
      title: 'Leave it blank',
      content: 'If this card is for a team member to fill in later.',
      data: { submitAction, image: '/img/placeholders/card-placeholder-2.png' },
      styles: {
        options: {
          width: 300,
        },
      },
      target: `#${VALUE_PROVIDER_TOUR_CONTAINER_ID}`,
      placement: 'right',
      disableBeacon: true,
    },
  ];
}

export function templateValueProviderTourSteps({ submitAction }: GetValueProviderTourStepsProps): Step[] {
  return [
    {
      title: 'Share with the team',
      content: 'This field will be applied to all cards, useful for company information.',
      data: { image: '/img/placeholders/card-placeholder-1.png' },
      styles: {
        options: {
          width: 300,
        },
      },
      target: `#${VALUE_PROVIDER_TOUR_CONTAINER_ID}`,
      placement: 'left',
      disableBeacon: true,
    },
    {
      title: 'Make it individual',
      content: 'Let team members fill with their own details, useful for personal information.',
      data: { submitAction, image: '/img/placeholders/card-placeholder-2.png' },
      styles: {
        options: {
          width: 300,
        },
      },
      target: `#${VALUE_PROVIDER_TOUR_CONTAINER_ID}`,
      placement: 'right',
      disableBeacon: true,
    },
  ];
}
